// these values reflect the enum defined on the device handler (signalR)
export const DeviceStages = {
  ClinicLogin: 0,
  PatientLogin: 1,
  Confirmation: 2,
  Tutorial: 4,
  Exam: 8,
  Pause: 16,
  Congratulations: 32,
  Calibration: 64,
};

// these values don't reflect the enum defined on the device handler (signalR)
// these values are based on the timeline displayed on the live update modal
// these values need to in order in terms of occurence, unlike the DeviceStages enum
export const DeviceStagesTimeline = {
  PatientLogin: 0,
  Confirmation: 1,
  Calibration: 2,
  Tutorial: 3,
  Exam: 4,
  Completed: 5,
  Terminated: 6,
};

// method to get the active step to be displayed on the timeline component within the live update modal
export const getActiveStep = (exam, possibleSteps, examStatus) => {
  if (!exam || !examStatus) return { index: -1, value: -1 };

  const index = possibleSteps.findIndex(
    (stepValue) => stepValue === examStatus.timelineStage
  );
  return { index, value: examStatus.timelineStage };
};

// method to get the texts for all stage options within the timeline component displayed within the live update modal
export const getDeviceStagesTimelineText = (
  stage,
  isExamOrTutorial,
  wordExamExtra,
  t
) => {
  switch (stage) {
    case DeviceStagesTimeline.PatientLogin:
      return t("word_patient_login");
    case DeviceStagesTimeline.Confirmation:
      return t("word_confirmation");
    case DeviceStagesTimeline.Tutorial:
      if (isExamOrTutorial) return `${t("word_tutorial")} (${wordExamExtra})`;
      return t("word_tutorial");
    case DeviceStagesTimeline.Calibration:
      return t("word_calibration");
    case DeviceStagesTimeline.Exam:
      if (isExamOrTutorial) return `${t("word_exam")} (${wordExamExtra})`;
      return t("word_exam");
    case DeviceStagesTimeline.Completed:
      return t("word_completed");
    default:
      return undefined;
  }
};
